<template>
  <v-app>
    <AllowedUserContainer :page-type="'admin'">
      <SessionShareContainer />
      <AdminHeader />
      <div class="d-flex">
        <AdminSidebarContainer />
        <div class="d-block" style='width: 100%'>
          <DataLoader
            v-if="generalItemsLoading"
            :loading="generalItemsLoading"
            style="margin-top: 100px"
          />
          <div
            v-else
            class="d-flex justify-space-between"
            style="position: relative; margin-top: 60px"
          >
            <router-view />
          </div>
          <slot />
        </div>
      </div>
    </AllowedUserContainer>
    <toaster />
    <loading-overlay />
    <SystemInformationConfirmDialog></SystemInformationConfirmDialog>
  </v-app>
</template>

<script>
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import LogoutBtn from '@/components/commons/LogoutBtn'
import DataLoader from '@/components/commons/DataLoader'
import AllowedUserContainer from '../../src/container/shared/AllowedUserContainer'
import SessionShareContainer from '../../src/container/shared/SessionShare'
import SitePermissionUtils, {
  PRODUCTS_SITUATION_ID
} from '@/mixins/site_permission_utils'
import urlUtils from '@/mixins/url_utils'
import { mapState, mapGetters } from 'vuex'
import SystemInformationConfirmDialog from '../../src/container/shared/SystemInformationDetailDialogs/confirm.vue'
import AdminHeader from '../../src/components/shared/AdminHeader'
import AdminSidebarContainer from '../../src/container/shared/AdminSidebarContainer'

export default {
  name: 'App',
  components: {
    AdminSidebarContainer,
    AdminHeader,
    Toaster,
    LoadingOverlay,
    LogoutBtn,
    DataLoader,
    AllowedUserContainer,
    SessionShareContainer,
    SystemInformationConfirmDialog
  },
  mixins: [SitePermissionUtils, urlUtils],
  data: () => ({
    generalItemsLoading: true,
    drawer: null,
    accountMenu: false,
    globalMenuItems: [
      {
        icon: 'mdi-home',
        text: 'ホーム',
        situations: [],
        router: { name: 'adminDashboard' }
      },
      {
        icon: 'mdi-pencil',
        text: '記事管理',
        situations: [],
        router: { name: 'adminPosts' }
      },
      {
        icon: 'mdi-cart',
        text: '商品管理',
        situations: [],
        siteSituations: [PRODUCTS_SITUATION_ID],
        router: { name: 'adminProducts' }
      },
      {
        icon: 'mdi-palette',
        text: 'デザイン',
        situations: ['site_design_configuration'],
        router: { name: 'adminDesigns' }
      },
      {
        icon: 'mdi-account',
        text: 'ユーザー',
        situations: [
          'admin_management',
          'expert_management',
          'contributor_management'
        ],
        router: { name: 'adminUsers' }
      },
      {
        icon: 'mdi-cogs',
        text: '設定',
        situations: [],
        router: { name: 'adminSettings' }
      }
    ]
  }),
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site,
      currentUser: (state) => state.UserStore.currentUser
    }),
    ...mapGetters('UserStore', ['judgePermissionBySituations']),
    permittedGlobalMenuItems: function () {
      return this.globalMenuItems.filter((item) => {
        if (item.situations.length === 0 && !item.siteSituations) {
          return true
        }
        if (item.siteSituations && this.isPermittedAll(item.siteSituations)) {
          return true
        }
        return this.judgePermissionBySituations(item.situations)
      })
    }
  },
  mounted: function () {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'SiteStore/setSite') {
        this.generalItemsLoading = false
      }
    })
  }
}
</script>

<style scoped lang="sass">
.l-mainHeader
  position: fixed
  border-bottom: 1px solid #BEBEBE
  background: #fff
  height: 100px
  display: flex
  justify-content: space-between
  width: 100%
  z-index: 99

  &__leftWrapper
    width: 150px
    height: 100%
    padding: 20px

  &__rightWrapper
    width: 150px
    height: 100%
    display: flex
    justify-content: center
    align-items: center

  &__gMenuWrapper
    min-width: 600px
    height: 50px
    display: flex
    justify-content: space-between

  &__gMenuItem
    min-width: 100px
    text-align: center
    margin: 0 10px

    a
      line-height: 48px
      display: block
      color: #6D6D6D
      padding-left: 3px
      padding-right: 6px

      span
        font-size: 14px
        margin-left: 5px
        line-height: 48px

    .active
      display: block
      color: #315ED9
      font-weight: 500
      border-bottom: 3px solid #315ED9
      box-sizing: border-box

      .v-icon
        color: #315ED9

  &__serviceLogoWrapper
    height: 50px
    width: 100%

  &__serviceLogo
    display: block
    margin: 0 auto
    width: 100px

  &__favicon
    display: block
    width: 60px
    height: 60px
    box-sizing: border-box
    border: 2px solid #D3D3D3
    border-radius: 10px
    margin: 0 auto

    &--sub
      display: flex
      justify-content: center
      align-items: center
      background: #F5F5F5

      span
        padding: 0
        font-size: 2.4rem
        font-weight: 500
        color: #6D6D6D
        padding-bottom: 8px
</style>
